module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Cond.d9601b0.eot";